export function clearCompanyData(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const companySpecificKeys = [
    'site',
    'camera',
    'dateRange',
    'dateValue',
    'selectedOrders',
    'selectedSpecies',
    'speciesFilterMode',
    'siteCameraInitialized',
  ];

  companySpecificKeys.forEach((key) => {
    window.localStorage.removeItem(key);
  });
}

